import {Component, ElementRef,} from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { ResultsSortSelectorDirective } from '../results-sort-selector.directive';
import { GedCfgFieldService } from '../../../redux/field/service/ged/ged-cfg-field.service';
import { GedAutocompletionService } from '../../../../modules/search/service/autocompletion/ged-autocompletion.service';

@Component({
  selector: 'app-ged-results-sort-selector',
  templateUrl: '../results-sort-selector.component.html',
  styleUrls: ['../results-sort-selector.component.scss']
})
export class GedResultsSortSelectorComponent extends ResultsSortSelectorDirective {

  constructor(
    fieldService: GedCfgFieldService,
    autocompletionService: GedAutocompletionService,
    translateService: TranslateService,
    element: ElementRef
  ) {
    super(fieldService, autocompletionService, translateService, element);
  }

}
